export const get = <T>(obj: T, path: string | string[]): any => {
  if (typeof path === "string") {
    path = path.split(".").filter(part => part.length > 0);
  }
  return path.reduce((acc: any, ck: string) => acc && acc[ck], obj);
};

export const waitFor = (
  selector: string,
  callback: () => void,
): Promise<void> => {
  return new Promise<void>(resolve => {
    const interval = setInterval(() => {
      if (get(window, selector)) {
        clearInterval(interval);
        callback();
        resolve();
      }
    }, 20);
  });
};

export const waitForCondition = (
  conditionFn: () => boolean,
  callback: () => void,
  errorCb: () => void,
  checkIntervalMs = 20,
  timeoutMs = 5000,
): Promise<void> => {
  let interval: NodeJS.Timeout;
  return new Promise<void>(resolve => {
    const timeout = setTimeout(() => {
      clearInterval(interval);
      errorCb();
      resolve();
    }, timeoutMs);
    interval = setInterval(() => {
      if (conditionFn()) {
        clearTimeout(timeout);
        clearInterval(interval);
        callback();
        resolve();
      }
    }, checkIntervalMs);
  });
};

export const initGlobalUtils = () => {
  window.get = get;
  window.waitFor = waitFor;
  window.waitForCondition = waitForCondition;
};
